import React, { Component } from "react";
import Modal from "react-modal";
import { PopupActionButton } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import {
  get_all_admin_pending_vendors,
  update_on_hold_vendors_info,
} from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import moment from "moment";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
  },
};

const onHoldReason = [
  { id: 1, name: "Profile Not Completed", value: "Profile Not Completed" },
  { id: 2, name: "Others", value: "Others" },
];

export class OnHoldPendingModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openOnHold: false,
      reason: "",
      comments: "",
    };
  }

  onHoldModel = (e) => {
    this.setState({
      openOnHold: !this.state.openOnHold,
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onHoldPendingAction = (e) => {
    const vendorId = this.props.data.vendor_id;
    const token = this.props.auth.user.accessToken;
    const formData = {
      blocked: {
        reason: this.state.reason,
        comment: this.state.comments,
        isBlocked:
          this.props.data &&
          this.props.data.vendor &&
          this.props.data.vendor.blocked &&
          this.props.data.vendor.blocked.isBlocked,
      },
      onHold: this.props.data.vendor.onHold === false ? true : false,
    };
    this.props.update_on_hold_vendors_info(
      formData,
      vendorId,
      token,
      this.onSuccessAPi
    );
  };

  onSuccessAPi = (e) => {
    const dateRange = this.props.selecTedDateRange;
    this.props.get_all_admin_pending_vendors(
      this.props.auth.user.accessToken,
      true,
      dateRange.startDate,
      dateRange.endDate
    );
    this.setState({
      openOnHold: !this.state.openOnHold,
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.props.data.vendor.onHold === true ? (
          <button
            className={"popup-cancel-button n_button_d_status font_18_m"}
            type="button"
            onClick={this.onHoldModel}
          >
            Resume
          </button>
        ) : (
          <button
            className={"popup-cancel-button n_button_d_status font_18_m"}
            type="button"
            onClick={this.onHoldModel}
          >
            Put On Hold
          </button>
        )}
        {/* <PopupActionButton
          buttonText="On Hold"
          buttonType="button"
          buttonClass={
            this.props.data.vendor.onHold === true ? "noButton" : "smallcancel"
          }
          onClick={this.onHoldModel}
        /> */}
        {this.props.data.vendor.onHold === false ? (
          <Modal
            isOpen={this.state.openOnHold}
            onRequestClose={this.onHoldModel}
            style={customStyles}
            className="super_admin_onhold_modal_body"
            contentLabel="Example Modal"
            // id="modal-termsAndConditions-subscription"
            ariaHideApp={false}
          >
            <div>
              <div className="sa_oh_mb_p-header">
                <h5 className="header_text">On Hold</h5>
              </div>
              <div>
                <h5 className="font_22_r c_gray mb-4">
                  Please provide your reason to put the restaurant on hold.
                </h5>
              </div>
              <form>
                <div>
                  <SelectBoxMUiInputComponent
                    displayNone={true}
                    selectLabel="Reason"
                    name="reason"
                    value={this.state.reason}
                    onChange={this.onChange}
                    getData={onHoldReason}
                  />
                </div>
                {this.state.reason === "Others" ? (
                  <div className="mt-4">
                    <NewInputText
                      name="comments"
                      onChange={this.onChange}
                      rows="4"
                      multiline={true}
                      value={this.state.comments}
                      labelText="Comments"
                      controlClass={"outlined-helperText "}
                    />
                  </div>
                ) : null}
                <div className="mt-4 d-flex">
                  <ReusableOnboardingButton
                    buttonTitle="Cancel Button"
                    buttonClass={
                      "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                    }
                    buttonText="Cancel"
                    onClick={this.onHoldModel}
                    buttonType="button"
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Save Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                    buttonText="Save"
                    buttonType="button"
                    onClick={this.onHoldPendingAction}
                  />
                </div>
              </form>
            </div>
          </Modal>
        ) : (
          <Modal
            isOpen={this.state.openOnHold}
            onRequestClose={this.onHoldModel}
            style={customStyles}
            className="super_admin_onhold_modal_body"
            contentLabel="Example Modal"
            // id="modal-termsAndConditions-subscription"
            ariaHideApp={false}
          >
            <div>
              <div className="sa_oh_mb_p-header">
                <h5 className="header_text">Remove Hold</h5>
              </div>
              <form>
                <div className="mt-4 d-flex">
                  <ReusableOnboardingButton
                    buttonTitle="Cancel Button"
                    buttonClass={
                      "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                    }
                    buttonText="Cancel"
                    onClick={this.onHoldModel}
                    buttonType="button"
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Save Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                    buttonText="Save"
                    buttonType="button"
                    onClick={this.onHoldPendingAction}
                  />
                </div>
              </form>
            </div>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

OnHoldPendingModel.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  selecTedDateRange: state.adminAllVendorsInfo?.set_select_date_range,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_admin_pending_vendors,
  update_on_hold_vendors_info,
})(withRouter(OnHoldPendingModel));
